'use strict';
const angular = require('angular');

export class GenericLookupComponent {
  /*@ngInject*/
  constructor() {
    this.data = [];
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.data = this.config.data;
    this.dataInitComplete = true;
  };

  ok(user) {
    this.close({$value: user});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.genericLookup', [])
  .component('genericLookup', {
    template: require('./generic-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: GenericLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/generic-lookup/generic-lookup.component.js